import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthAccessProvider } from '../core/core.auth';
import { DatePipe } from '@angular/common';
import { MessageProvider } from '../service/message.service';
import { PresenzeService } from '../service/presenze.service';
import { BusyProvider } from '../service/busy.service';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { UserContext, BaseComponent, BaseResponse, CheckInResponse, 
         CheckedInResponse, ExitCausesResponse, ExitCause, Activity, EnterCause } from '../core/core.component';
import { AppConstants } from '../core/app.constants';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { ActivityService } from '../service/activity.service';

declare var $: any;

@Component({
  selector: 'app-cartellino',
  templateUrl: './cartellino.component.html',
  styleUrls: ['./cartellino.component.css'],
  host: { '(window:keydown)': 'shortcutHandler($event)' },
  providers: [PresenzeService, ActivityService]
})
export class CartellinoComponent extends BaseComponent implements OnInit, OnDestroy {

    userContext: UserContext;
    checkOutOK: boolean = false;
    lastCheckInTime: number;
    lastCheckOutTime: number;
    totWorkedString: string;
    existsCheckIn: boolean = false;
    exitCauses: ExitCause[] = new Array();
    enterCauses: EnterCause[] = new Array();
    refreshAnomalies:  Subject<boolean> = new Subject<boolean>();
    serverTsTimeString : string = null;
    subscriptionTimer: Subscription = null;
    subscriptionServerTs: Subscription = null;

    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider, 
            private presenzeService: PresenzeService,
            private activityService: ActivityService,
            private busyProvider: BusyProvider,
            private datePipe: DatePipe)  
    { 
        super(authAccess, router, messageProvider);
        this.messageProvider.clearAll();
        this.userContext = this.authAccess.getUserContext();
    }
    

  ngOnInit() {
    this.subscriptionServerTs = this.presenzeService.serverTimestamp().subscribe(
        result => {
            let serverTs = new Date();
            serverTs.setTime(Number(result.message));
            this.serverTsTimeString = this.datePipe.transform(serverTs, 'HH:mm');
            let timer = Observable.timer((60 - serverTs.getSeconds()) * 1000, 60000);
            this.subscriptionTimer = timer.subscribe(
            t => {
                serverTs.setTime(serverTs.getTime() + 60000);
                this.serverTsTimeString = this.datePipe.transform(serverTs, 'HH:mm');
            });
            this.isUserCheckedIn();
        },
        error => {
            this.handleError(error);
        }
    );
    this.presenzeService.getEnterCauses(this.userContext.srmToken).subscribe(
        result => {
            this.enterCauses  = result.enterCauses;
        },
        error => {
            this.handleError(error);
    });
  }

  ngOnDestroy()  {
      if (this.subscriptionTimer != null) {
          this.subscriptionTimer.unsubscribe();
      }
      if (this.subscriptionServerTs != null) {
          this.subscriptionServerTs.unsubscribe();
      }
  }
  
  checkIn(cause: number) {
      this.userContext = this.authAccess.getUserContext();
      if (this.userContext != null) {
          this.busyProvider.showBusyIndicator();
          this.presenzeService.checkIn(this.userContext.srmToken, cause).timeout(environment.SERVICE_TIMEOUT).
          subscribe(
               result => {
                   this.busyProvider.hideBusyIndicator();
                   this.messageProvider.clearAll();
                   this.lastCheckInTime = result.checkInTs;
                   this.existsCheckIn = true;
                   if (result.status == 201) {
                       this.messageProvider.notifyWarning(result.message);
                   } else {
                       this.messageProvider.notifyMessage("Ingresso timbrato correttamente");
                   }
                   this.refreshAnomalies.next(true);
               },
               error => {
                   this.busyProvider.hideBusyIndicator();
                   this.handleError(error);
               });
      } else {
          this.authAccess.invalidate();
      }
  }
  
  isUserCheckedIn() {
      this.userContext = this.authAccess.getUserContext();
      if (this.userContext != null) {
          this.presenzeService.isCheckedIn(this.userContext.srmToken).subscribe(
               result => {
                   this.messageProvider.clearAll();
                   this.lastCheckInTime = result.checkInTs;
                   this.existsCheckIn = result.isCheckedIn;
               },
               error => {
                   this.handleError(error);
               });
      } else {
          this.authAccess.invalidate();
      }
  }
  
  checkOut(cause: number)  {
    $("#dialog").modal('hide');
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext != null)  {
        this.busyProvider.showBusyIndicator();
        this.presenzeService.checkOut(this.userContext.srmToken, cause).timeout(environment.SERVICE_TIMEOUT).subscribe(
            result => {
                this.busyProvider.hideBusyIndicator();
                this.messageProvider.clearAll();
                this.lastCheckOutTime = result.checkOutTs;
                this.checkOutOK = true;
                this.existsCheckIn = false;
                if (result.status == 201) {
                    this.messageProvider.notifyWarning(result.message);
                } else {
                    this.messageProvider.notifyMessage("Uscita timbrata correttamente");
                }
                this.totWorkedString = "";
                this.presenzeService.timeworked(this.userContext.srmToken, new Date(), null).subscribe(
                    result => {
                        this.totWorkedString = AppConstants.formatDuration(result.hours, result.minutes);
                        var timeworked = result;
                        if (cause == 3) {
                            var today = new Date();
                            this.activityService.search(this.userContext.srmToken, today, today, null, null).subscribe(
                                result => {
                                    let diff = (timeworked.hoursValued + timeworked.minutesValued / 60);
                                    result.activities.forEach(activity => {
                                        if (this.datePipe.transform(activity.inserted, 'ddMMyyyy') == this.datePipe.transform(today, 'ddMMyyyy')) {
                                            diff = diff - activity.spentHours - activity.spentMinutes / 60;
                                        }
                                    });
                                    if (diff > 0) {
                                        var activity = new Activity();
                                        activity.spentHours = Math.floor(diff);
                                        activity.spentMinutes = (diff - activity.spentHours) * 60;
                                        this.activityService.openActivityDetail(activity);
                                    }        
                                },
                                error => {
                                    this.handleError(error);
                            });
                        }
                    },
                    error => {
                    this.handleError(error);
                });
            },
            error => {
                this.busyProvider.hideBusyIndicator();
                this.handleError(error);
            });
    } else {
        this.authAccess.invalidate();
    }
  }
  
  showExitCauses() {
      this.userContext = this.authAccess.getUserContext();
      if (this.userContext != null) {
          // esegue checkout
          this.presenzeService.getExitCauses(this.userContext.srmToken).subscribe(
               result => {
                   this.exitCauses = result.exitCauses;
                   $("#dialog").modal({
                       backdrop: 'static'
                   });
               },
               error => {
                   this.handleError(error);
               });
      } else {
          this.authAccess.invalidate();
      }
  }
  
  shortcutHandler(event) {
      // INS -> checkin
      if (event.keyCode == 45 && !this.existsCheckIn) {
          if (this.enterCauses && this.enterCauses.length > 0) {
              this.checkIn(this.enterCauses[0].id);
          }
      }
      // FINE -> causali di uscita
      if (event.keyCode == 35 && !event.ctrlKey && this.existsCheckIn) {
          this.showExitCauses();
      }
      // CTRL + FINE -> checkout fine giornata
      if (event.keyCode == 35 && event.ctrlKey && this.existsCheckIn) {
          this.checkOut(3);
      }
      // CTRL + PAUSA -> checkout pausa pranzo
      if (event.keyCode == 19 && this.existsCheckIn) {
          this.checkOut(1);
      }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/cartellino/cartellino.component.ts